import { Component, OnInit } from '@angular/core';
import { SharedService } from '../../layouts/shared-service';
import { CustomValidators } from 'ng2-validation';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { MdDialog, MdDialogRef, MdDialogConfig } from '@angular/material';
import {Router, ActivatedRoute, Params} from '@angular/router';
import { environment } from 'environments/environment.prod';
import { httpservice } from 'http/http';
const breadcrumb: any[] = [
  {
    title: 'Home'
   
  },
  {
    title: 'Customer'
 
  },
  {
    title: 'Edit customer'

  }
];


@Component({
  selector: 'page-customer-form-edit',
  templateUrl: './customer-form-edit.html',
  styleUrls: ['./customer-form-edit.scss']
})


export class PageCustomerEdit implements OnInit {
  pageTitle: string = environment.sysName;
  breadcrumb: any[] = breadcrumb;
  public form: FormGroup;
  data: any;

  
  //diaglog
  dialogRef: MdDialogRef<CustomerEditDialog>;
  selectedOption: string;

  tc_id:string;
  tb21f_id:string;
  rows=[]
  arrContact=[];
  fullname:string;
  shortname:string;
  contactName:string;
  email:string;
  phone:string;
  website:string;
  address:string;
  taxid:string;
  branch:string;
  gIndex: any = null; gIndexCk: boolean = false;
  ckNullContact: boolean = false;

  constructor(private httpservice:httpservice,private activatedRoute: ActivatedRoute,public dialog: MdDialog,private fb: FormBuilder, private _sharedService: SharedService,private router: Router) {
    this._sharedService.emitChange(this.pageTitle);
    this.activatedRoute.params.subscribe((params: Params) => {
      this.tc_id = params['id'];
      this.getDataStart();
    });
  }

    openDialog() {
    let dialogRef = this.dialog.open(CustomerEditDialog);
     dialogRef.afterClosed().subscribe(result => {
      if(result==='1'){
        this.postString();
      }else{
      }
    });
  }

  
  openDialogDelete(id:String) {
    let dialogRef = this.dialog.open(CustomerEditDialog);
     dialogRef.afterClosed().subscribe(result => {
      if(result==='1'){
        this.delete(id);
      }else{
      }
    });
  }

  setEdit(id:any,index: any) {
    this.tb21f_id = id;
    this.gIndexCk=true;
    this.form.controls.contactname.setValue(this.rows[index].tb21f_name);
    this.form.controls.email.setValue(this.rows[index].tb21f_email);
    this.form.controls.phone.setValue(this.rows[index].tb21f_phone);
    this.form.controls.department.setValue(this.rows[index].tb21f_department);
  }

  edit() {
    let dialogRef = this.dialog.open(customerLoadingEditDialog, { disableClose: true });
    let instance = dialogRef.componentInstance;
    instance.Message = "wait.....";
    let value = {
      tb21f_name: this.form.controls.contactname.value,
      tb21f_phone: this.form.controls.phone.value,
      tb21f_email: this.form.controls.email.value,
      tb21f_department: this.form.controls.department.value,
      id:this.tb21f_id
    }

    this.httpservice.fetchpost('editCustomerContact.php',value,(cb)=>{
      this.getDataStart();
      this.gIndexCk = false;
      this.form.controls.contactname.reset();
      this.form.controls.phone.reset();
      this.form.controls.email.reset();
      this.form.controls.department.reset();
      this.dialog.closeAll();
    });
  
  }



  add(){
    let value = {
      contactname:this.form.controls.contactname.value,
      phone:this.form.controls.phone.value,
      email:this.form.controls.email.value,
      department:this.form.controls.department.value,
      tc_id:this.tc_id
    }
    this.httpservice.fetchpost('insertDataPostCustomerContact.php',value,data=>{
      this.form.controls.contactname.reset();
      this.form.controls.phone.reset();
      this.form.controls.email.reset();
      this.form.controls.department.reset();
      this.getDataStart();

    });
  }

  delete(id:String){
    let dialogRef = this.dialog.open(customerLoadingEditDialog, { disableClose: true });
    let instance = dialogRef.componentInstance;
    instance.Message = "wait.....";
    let value = {id:id};
    this.httpservice.fetchpost('deleteDataContact.php',value,cb=>{
      this.getDataStart();
      this.dialog.closeAll();
    });
  }


  postString() {
    let dialogRef = this.dialog.open(customerLoadingEditDialog, { disableClose: true });
    let instance = dialogRef.componentInstance;
    instance.Message = "wait.....";

    let value = {
      branch:this.form.controls.branch.value,
      taxid:this.form.controls.taxid.value,
      address:this.form.controls.address.value,
      id:this.tc_id,
      shortname:this.form.controls.shortname.value.replace(/&/g, '^'),
      fullname:this.form.controls.fullname.value.replace(/&/g, '^'),
      website:this.form.controls.website.value
    };

    this.httpservice.fetchpost('editCustomer.php',value,cb=>{
      this.dialog.closeAll();
      this.router.navigateByUrl('default-layout/customer');

    });

  }

getDataStart(){
  let dialogRef = this.dialog.open(customerLoadingEditDialog, { disableClose: true });
  let instance = dialogRef.componentInstance;
  instance.Message = "wait.....";

  this.httpservice.fetchget('getJSON_customer.php?id='+this.tc_id,data=>{
    this.fullname = data[0].tc_compay_fullname;
    this.shortname = data[0].tc_company_shortname;
    this.address = data[0].tc_address;
    this.taxid = data[0].tc_taxid;
    this.branch = data[0].tc_branch;
    this.website = data[0].tc_website;
    this.rows = data[0].arrContact;
    this.dialog.closeAll();
  });
}

  ngOnInit() {
    this.form = this.fb.group({
      //stateCtrl: [null, Validators.compose([Validators.required])],
      shortname: [null, Validators.compose([Validators.required])],
      fullname: [null, Validators.compose([Validators.required])],
      contactname: [null, Validators.compose([Validators.required])],
      phone: [null, Validators.compose([Validators.required])],
      email: [null, Validators.compose([Validators.required])],
      website: [null, Validators.compose([Validators.required])],
      address: [null, Validators.compose([Validators.required])],
      taxid: [null, Validators.compose([Validators.required])],
      branch: [null, Validators.compose([Validators.required])],
      department:[null, Validators.compose([Validators.required])]
    });
  }
}

//dialog
@Component({
  selector: 'customer-dialog',
  templateUrl: 'customer-dialog.html',
})
export class CustomerEditDialog {
  Message = 'What would you like to do?';
  constructor(public dialogRef: MdDialogRef<CustomerEditDialog>) {}
}

//dialog
@Component({
  selector: 'loading-dialog',
  templateUrl: 'loading-dialog.html',
})
export class customerLoadingEditDialog {
  Message = '';
  Title = '';
  constructor(public dialogRef: MdDialogRef<customerLoadingEditDialog>) { }
}



// WEBPACK FOOTER //
// /Users/bizqsoft/Documents/project/ibqs/ibqs-dip-2023-09-09/src/app/pages/customer/customer-form-edit.ts